import { useMemo, useState } from "react";

export function useSearch<T>(
  data: T[],
  searchKeys: (keyof T)[]
) {
  const [search, setSearch] = useState("");

  const filteredData = useMemo(() => {
    if (!search.trim()) return data;

    return data.filter((item) =>
      searchKeys.some((key) => {
        const value = item[key];

        return String(value || "")
          .toLowerCase()
          .includes(search.toLowerCase());
      })
    );
  }, [data, search, searchKeys]);

  return {
    search,
    setSearch,
    filteredData,
  };
}